fragment DocumentScanMetadata on Document {
  id
  scanMetadata {
    date
    scanId
    sequenceId
  }
}
